import { render, staticRenderFns } from "./Mdfe.vue?vue&type=template&id=8a2d55f8&scoped=true&"
import script from "./Mdfe.vue?vue&type=script&lang=js&"
export * from "./Mdfe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a2d55f8",
  null
  
)

export default component.exports